import { render } from "./TvmDealerSpecials.vue?vue&type=template&id=4a050bb4&scoped=true"
import script from "./TvmDealerSpecials.js?vue&type=script&lang=js&external"
export * from "./TvmDealerSpecials.js?vue&type=script&lang=js&external"

import "./TvmDealerSpecials.vue?vue&type=style&index=0&id=4a050bb4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a050bb4"],['__file',"src/Components/ChatWidget/TvmDelaerSpecials/TvmDealerSpecials.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a050bb4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a050bb4', __exports__)) {
    api.reload('4a050bb4', __exports__)
  }
  
  module.hot.accept("./TvmDealerSpecials.vue?vue&type=template&id=4a050bb4&scoped=true", () => {
    api.rerender('4a050bb4', render)
  })

}


export default __exports__